module.exports = __webpack_public_path__ + "static/media/train-alone.09c089e5.png";